import { CardTabsAttachment as CardTabsAttachmentComponent } from "./CardTabsAttachment.component";

export const CardTabsAttachment = CardTabsAttachmentComponent;
